// extracted by mini-css-extract-plugin
export default {"influencerlinks":"tn-z","basicPrimaryBtn":"un-z","disabled":"vn-z","basicBtn":"wn-z"};